import { PasswordInput as V2PasswordInput } from "components/ui/v2/password-input";
import React from "react";

const PasswordInput = React.forwardRef((props: any, ref) => {
  return (
    <V2PasswordInput
      ref={ref}
      {...props}
    />
  );
});

PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
